import httpClient from '../../../api/httpClient';
import API_CONFIG from '../../../config/api.config';
import { 
  CreateConsultationDto, 
  UpdateConsultationDto, 
  ConsultationResponseDto
} from '../types/consultation';

const ENDPOINT = `${API_CONFIG.ENDPOINTS.APPOINTMENTS}/:appointmentId/consultation`;

export const consultationApi = {
  /**
   * Get consultation by appointment ID
   */
  getByAppointmentId: async (appointmentId: string): Promise<ConsultationResponseDto> => {
    const url = ENDPOINT.replace(':appointmentId', appointmentId);
    const response = await httpClient.get<ConsultationResponseDto>(url);
    return response.data;
  },

  /**
   * Create a new consultation
   */
  create: async (appointmentId: string, data: CreateConsultationDto): Promise<ConsultationResponseDto> => {
    const url = ENDPOINT.replace(':appointmentId', appointmentId);
    console.log('Sending consultation create request to:', url);
    console.log('Request data:', JSON.stringify(data, null, 2));
    
    try {
      const response = await httpClient.post<ConsultationResponseDto>(url, data);
      console.log('Create consultation response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating consultation:', error);
      throw error;
    }
  },

  /**
   * Update an existing consultation
   */
  update: async (appointmentId: string, data: UpdateConsultationDto): Promise<ConsultationResponseDto> => {
    const url = ENDPOINT.replace(':appointmentId', appointmentId);
    console.log('Sending consultation update request to:', url);
    console.log('Request data:', JSON.stringify(data, null, 2));
    
    try {
      const response = await httpClient.put<ConsultationResponseDto>(url, data);
      console.log('Update consultation response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error updating consultation:', error);
      throw error;
    }
  },

  /**
   * Delete a consultation
   */
  delete: async (appointmentId: string): Promise<void> => {
    const url = ENDPOINT.replace(':appointmentId', appointmentId);
    await httpClient.delete(url);
  },
};
